import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import dynamic from "next/dynamic"
import Image from "next/image";
import { Fragment, useEffect, useState } from "react";
import { capitalizeFirstLetter, count, isDefined } from "../../config/helpers";
import { useRouter } from "next/router";

import "react-modal-video/scss/modal-video.scss";
import ModalVideo from "react-modal-video";
import './ShowCase.module.css'
import { Gallery, Item } from 'react-photoswipe-gallery'
import  CardActions from "@mui/material/CardActions";
import Card from "@mui/material/Card";


const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));
const ArticlePagination = dynamic(() => import("../Article/ArticlePagination"));
const ShowcaseSchema = dynamic(() => import("../Schemas/ShowcaseSchema"));

const ShowcaseLayout = (props) => {
    const router = useRouter();
    const {
        template_page_settings,
        breadcrumb, 
        per_page,
        showcase, 
        tag,
        tags,
        pageType,
        unique_titles
    } = props;

    const [filter, setFilter] = useState(tag);
    const [page, setPage] = useState(showcase.current_page)
    const [ isOpen, setIsOpen] = useState(false)
   

    function openModal(){
        setIsOpen(true)
    }

    const gridType = {
        videos: {
            xs: 12,
            sm: 6,
            lg: 4
        },
        gallery: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 3,
        }
    }

    const handleChange = (event) => {
        // const page = !query.page ? 1 : query.page
        setFilter(event.target.value);
        let pageUrl = `/${pageType}`;
        if(event.target.value != 'all'){
            pageUrl += `/${event.target.value}`
        }
        router.push(pageUrl);
    };

    const handlePageChange = (event, value) => {
        //remove the current page from url path and insert new page value
        const url = router.asPath.replace(`?page=${page}`, '')
        router.push(`${url}?page=${value}`)
        setPage(value)
    }

    // for react video modal 
        let the_idx = null
        const [indx, setIndx]= useState(null)
        useEffect(()=>{
    if(the_idx!== null){
        setIndx(the_idx)
        console.log(the_idx)
    }
    },[indx])

    return (
        <BoxContainer className="mt-4" template_page_settings={template_page_settings}>

            {pageType == 'gallery' && <ShowcaseSchema images={showcase.data}/>}

            <Typography component="h1" variant="h1" className="d-none">{breadcrumb.last}</Typography>

            <Grid className="mb-4" container>
                <Grid item xs={4}>
                    {count(tags) > 0 && (
                        <FormControl fullWidth>
                            <InputLabel id="tag-filter">Filter by tags:</InputLabel>
                            <Select
                                labelId="tag-filter"
                                id="tag-filter"
                                value={filter}
                                label="Filter"
                                onChange={handleChange}
                            >
                                <MenuItem value="all">All</MenuItem>
                                {tags.map((sgl_tag, idx) => (
                                    <MenuItem key={idx} selected={tag == sgl_tag.slug ? true : false} value={sgl_tag.slug}>{capitalizeFirstLetter(sgl_tag.name)}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </Grid>
            </Grid>

            <ArticlePagination 
                count={showcase.last_page}
                page={page}
                handleChange={handlePageChange}
            />
            {pageType == 'gallery' && (
                <Typography className="mt-4">On this gallery page the following topics are covered:
                {count(Object.keys(showcase.data)) > 0 && count(Object.keys(unique_titles)) > 0 && (
                    Object.values(unique_titles).map((title, idx) => (
                        <Fragment key={idx}>
                            {` ${title}${idx != unique_titles.length -1 ? ',' : ''}`} 
                        </Fragment>
                    ))
                )}  
                </Typography>
            )}

            <Grid spacing={2} justifyContent='space-around' container >
                        
            <Gallery withCaption>
            {count(Object.keys(showcase.data)) > 0 && (
                Object.keys(showcase.data).map((key, idx) => (
                    <Grid className="mt-4 mb-4" key={idx} item {...gridType[pageType]} >
                            {pageType == 'gallery' ? (
                                <Fragment key={idx}>
                                    <Item 
                                        original={showcase.data[key].zoom_image}
                                        thumbnail={showcase.data[key].zoom_image}
                                        width="750"
                                        height="750"
                                        caption={showcase.data[key].description ? showcase.data[key].description : showcase.data[key].title}
                                    
                                    >
                                        {({ ref, open }) => (
                                            
                                            <Card sx={{
                                            minHeight: '150px',
                                            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                            paddingBottom:'5%',
                                            zIndex:0,
                                            }} className="position-relative h-100 mr-2 ml-2 pb-1"
                                            ref={ref}
                                            onClick={open}>
                                                
                                                <Box sx={{objectFit:'cover'}}>
                                                <Image style={{width:'100%'}}
                                                    src={showcase.data[key].image}
                                                    alt={showcase.data[key].description ? showcase.data[key].description : showcase.data[key].title}
                                                    width={300}
                                                    height={300}
                                                />
                                                </Box>
                                                <CardActions className="mt-2 pb-0 justify-center align-items-center">

                                                <Typography sx={{fontSize:16, color:'primary.main', fontWeight:'500'}}>
                                                    {showcase.data[key].title}
                                                </Typography>
                                                </CardActions>
                                            </Card>
                                        )}
                                    </Item>
                                    
                                </Fragment>

                            ) : (
                            <Fragment key={idx}>
                                <Box sx={{display:'none'}}>
                                {the_idx = idx}
                                </Box>
                                <ModalVideo 
                                key={idx}
                                channel='youtube' 
                                autoplay 
                                // url={`https://i.ytimg.com/vi/${showcase.data[key].video}/maxresdefault.jpg`} 
                                videoId={`${showcase.data[key].video}`}
                                isOpen={the_idx == idx ? isOpen : false} 
                                onClose={() => setIsOpen(false)}
                                />
                                <Card sx={{
                                    minHeight: '150px',
                                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                    paddingBottom:'5%',
                                    zIndex:0,
                                    position:'relative'
                                }} 
                                className="position-relative h-100 mr-2 ml-2 pb-1" onClick={()=> setIsOpen(true)}>
                                    {/* <Image
                                        src={`https://i.ytimg.com/vi/${showcase.data[key].video}/maxresdefault.jpg`}
                                        alt={showcase.data[key].title}
                                        fill
                                        sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                        priority={true}
                                        />

                        
                                    <Typography 
                                        sx={{
                                            position: 'relative',
                                            minHeight: '40px',
                                            top: '90%',
                                            padding: '5px',
                                            background: '#ecf0f1',
                                            border: '0.1px solid grey',
                                            color:'primary.main'
                                        }}
                                        >
                                        {showcase.data[key].title}
                                    </Typography> */}
                                <Box sx={{objectFit:'cover',}}>
                                    <Image style={{  height:'fit-content', width:'100%'}}
                                    src={`https://i.ytimg.com/vi/${showcase.data[key].video}/maxresdefault.jpg`}
                                    alt={showcase.data[key].title}
                                    width={300}
                                    height={300}
                                    priority= {true}
                                    />
                                </Box>
                                <CardActions className="mt-2 pb-0 justify-center align-items-center">
                                    <Typography sx={{fontSize:16, color:'primary.main', fontWeight:'500'}}>{showcase.data[key].title}</Typography>
                                </CardActions>
                                </Card>
                            </Fragment>
                            )}
                    </Grid>
                ))
            )

            }
            </Gallery>

            </Grid>

            {pageType == 'gallery' && (
                <Box className="mt-5 mb-3">
                    <Typography>
                        Why do we take pictures? They capture moments in time which remind us of events during our existence and allow us to reminisce and remember. 
                        They provoke feeling and emotion, transporting us back to the exact moment in time. The images we take can be enjoyed and explored for years to come. 
                        These are some of the many reasons why the team at {process.env.brand.brand_name} have created a gallery for you - our client.
                    </Typography>

                </Box>
            )}

           <Box className='position-relative w-100 mt-2'>
            <ArticlePagination 
                count={showcase.last_page}
                page={page}
                handleChange={handlePageChange}
            />
            </Box> 


        </BoxContainer>
    )
}

export default ShowcaseLayout
// import Typography from "@mui/material/Typography";
// import Grid from "@mui/material/Grid";
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import Box from '@mui/material/Box';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
// import dynamic from "next/dynamic"
// import Image from "next/image";
// import { Fragment, useState } from "react";
// import { capitalizeFirstLetter, count, isDefined } from "../../config/helpers";
// import { useRouter } from "next/router";

// import { Gallery, Item } from 'react-photoswipe-gallery'
// const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));
// const ArticlePagination = dynamic(() => import("../Article/ArticlePagination"));
// const ShowcaseSchema = dynamic(() => import("./ShowcaseSchema"));

// const ShowcaseLayout = (props) => {
//     const router = useRouter();
//     const {
//         template_page_settings,
//         breadcrumb, 
//         per_page,
//         showcase, 
//         tag,
//         tags,
//         pageType,
//         unique_titles
//     } = props;

//     const [filter, setFilter] = useState(tag);
//     const [page, setPage] = useState(showcase.current_page)

//     const gridType = {
//         videos: {
//             xs: 12,
//             sm: 6,
//             lg: 4
//         },
//         gallery: {
//             xs: 12,
//             sm: 6,
//             md: 4,
//             lg: 3,
//         }
//     }

//     const handleChange = (event) => {
//         // const page = !query.page ? 1 : query.page
//         setFilter(event.target.value);
//         let pageUrl = `/${pageType}`;
//         if(event.target.value != 'all'){
//             pageUrl += `/${event.target.value}`
//         }
//         router.push(pageUrl);
//     };

//     const handlePageChange = (event, value) => {
//         //remove the current page from url path and insert new page value
//         const url = router.asPath.replace(`?page=${page}`, '')
//         router.push(`${url}?page=${value}`)
//         setPage(value)
//     }

    
    
//     return (
//         <BoxContainer className="mt-4" mobileClasses={"pl-0 pr-0"} template_page_settings={template_page_settings}>

//             {pageType == 'gallery' && <ShowcaseSchema images={showcase.data}/>}

//             <Typography component="h1" variant="h1" className="d-none">{breadcrumb.last}</Typography>

//             <Grid className="mb-4" container>
//                 <Grid item xs={4}>
//                     {count(tags) > 0 && (
//                         <FormControl fullWidth>
//                             <InputLabel id="tag-filter">Filter by tags:</InputLabel>
//                             <Select
//                                 labelId="tag-filter"
//                                 id="tag-filter"
//                                 value={filter}
//                                 label="Filter"
//                                 onChange={handleChange}
//                             >
//                                 <MenuItem value="all">All</MenuItem>
//                                 {tags.map((sgl_tag, idx) => (
//                                     <MenuItem key={idx} selected={tag == sgl_tag.slug ? true : false} value={sgl_tag.slug}>{capitalizeFirstLetter(sgl_tag.name)}</MenuItem>
//                                 ))}
//                             </Select>
//                         </FormControl>
//                     )}
//                 </Grid>
//             </Grid>

//             <ArticlePagination 
//                 count={showcase.last_page}
//                 page={page}
//                 handleChange={handlePageChange}
//             />
//             {pageType == 'gallery' && (
//                 <Typography className="mt-4">On this gallery page the following topics are covered:
//                 {count(Object.keys(showcase.data)) > 0 && count(Object.keys(unique_titles)) > 0 && (
//                     Object.values(unique_titles).map((title, idx) => (
//                         <Fragment key={idx}>
//                             {` ${title}${idx != unique_titles.length -1 ? ',' : ''}`} 
//                         </Fragment>
//                     ))
//                 )}  
//                 </Typography>
//             )}

//             <Grid spacing={3} container>
                        
//             <Gallery withCaption>
//             {count(Object.keys(showcase.data)) > 0 && (
//                 Object.keys(showcase.data).map((key, idx) => (
//                     <Grid className="mt-4 mb-4" key={idx} item {...gridType[pageType]}>
//                             {pageType == 'gallery' ? (
//                                 <Fragment key={idx}>
//                                     <Item
//                                         original={showcase.data[key].zoom_image}
//                                         thumbnail={showcase.data[key].zoom_image}
//                                         width="750"
//                                         height="750"
//                                         caption={showcase.data[key].description ? showcase.data[key].description : showcase.data[key].title}
//                                     >
//                                         {({ ref, open }) => (
//                                             <Box sx={{
//                                                 minHeight: '250px'
//                                             }} className="position-relative h-100"
//                                             ref={ref}
//                                             onClick={open}>
//                                                 <Image

//                                                     src={showcase.data[key].image}
//                                                     alt={showcase.data[key].description ? showcase.data[key].description : showcase.data[key].title}
//                                                     fill
    
//                                                     sizes="(max-width: 768px) 100vw,
//                                                     (max-width: 1200px) 50vw,
//                                                     33vw"
//                                                 />

//                                                 <Typography 
//                                                     sx={{
//                                                         position: 'relative',
//                                                         minHeight: '40px',
//                                                         top: '90%',
//                                                         padding: '5px',
//                                                         background: '#ecf0f1',
//                                                         border: '0.1px solid grey',
//                                                     }}
//                                                 >
//                                                     {showcase.data[key].title}
//                                                 </Typography>
//                                             </Box>
//                                         )}
//                                     </Item>
                                    
//                                 </Fragment>

//                             ) : (
//                             <Fragment key={idx}>
//                                 <Box sx={{
//                                     minHeight: '250px'
//                                 }} 
//                                     className="position-relative h-100">

//                                     <Image
//                                         src={`https://i.ytimg.com/vi/${showcase.data[key].video}/maxresdefault.jpg`}
//                                         alt={showcase.data[key].title}
//                                         fill
//                                         sizes="(max-width: 768px) 100vw,
//                                         (max-width: 1200px) 50vw,
//                                         33vw"
//                                     />
//                                     <Typography 
//                                         sx={{
//                                             position: 'relative',
//                                             minHeight: '40px',
//                                             top: '90%',
//                                             padding: '5px',
//                                             background: '#ecf0f1',
//                                             border: '0.1px solid grey',
//                                         }}
//                                     >
//                                         {showcase.data[key].title}
//                                     </Typography>

//                                     {/* TODO: video player */}
//                                 </Box>
//                             </Fragment>
//                             )}
//                     </Grid>
//                 ))
//             )

//             }
//             </Gallery>

//             </Grid>

//             {pageType == 'gallery' && (
//                 <Box className="mt-5 mb-3">
//                     <Typography>
//                         Why do we take pictures? They capture moments in time which remind us of events during our existence and allow us to reminisce and remember. 
//                         They provoke feeling and emotion, transporting us back to the exact moment in time. The images we take can be enjoyed and explored for years to come. 
//                         These are some of the many reasons why the team at {process.env.brand.brand_name} have created a gallery for you - our client.
//                     </Typography>

//                 </Box>
//             )}

            
//             <ArticlePagination 
//                 count={showcase.last_page}
//                 page={page}
//                 handleChange={handlePageChange}
//             />


//         </BoxContainer>
//     )
// }

// export default ShowcaseLayout